type HoldListener = () => void;

const activeHolds = new Set<symbol>();
const listeners = new Set<HoldListener>();
let pendingNavigation: { destination: string; mode: "assign" | "replace" } | null = null;

function emitHoldChange() {
  for (const listener of listeners) listener();
}

/**
 * Keeps the current document alive while an established call finishes.
 * The hold carries no tenant, call, session, or credential data.
 */
export function acquireAuthNavigationHold(): () => void {
  const hold = Symbol("auth-navigation-hold");
  activeHolds.add(hold);
  emitHoldChange();

  return () => {
    if (!activeHolds.delete(hold)) return;
    emitHoldChange();

    if (activeHolds.size === 0 && pendingNavigation) {
      const navigation = pendingNavigation;
      pendingNavigation = null;
      window.location[navigation.mode](navigation.destination);
    }
  };
}

export function replaceWhenAuthNavigationReady(destination: string): void {
  if (activeHolds.size > 0) {
    pendingNavigation ??= { destination, mode: "replace" };
    return;
  }

  window.location.replace(destination);
}

export function assignWhenAuthNavigationReady(destination: string): void {
  if (activeHolds.size > 0) {
    pendingNavigation ??= { destination, mode: "assign" };
    return;
  }

  window.location.assign(destination);
}

export function getAuthNavigationHoldSnapshot(): boolean {
  return activeHolds.size > 0;
}

export function subscribeAuthNavigationHold(listener: HoldListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
